export enum TARGET {
    SELF = '_self',
    BLANK = '_blank',
}
